import React from 'react';

// Removed Modal, Select, Option imports
// Added CBModal, CBSelect imports
import { CBModal, CBSelect } from '../../../core/components/cbd';


const planOptions = [
	'calendarbridge-pro',
	'basic-monthly',
	'basic-yearly',
	'premium-monthly',
	'premium-yearly',
	'pro-monthly',
	'pro-yearly',
	'admin-monthly',
	'admin-yearly'
];

const EditPlanModal = ({
	currentPlan,
	visible,
	handleOk,
	confirmLoading,
	handleCancel,
	setNewPlan
}) => {
	function handleChange(value) {
		
		setNewPlan(value.value);
	}
	return (
		// Replaced Modal with CBModal
		<CBModal
			title="Edit Plan (tries to update stripe)"
			visible={visible}
			onPositiveClick={handleOk} // Map onOk
			confirmLoading={confirmLoading} // Assuming CBModal supports this
			onCancelClick={handleCancel} // Map onCancel
		>
			{/* Replaced Select with CBSelect */}
			<CBSelect
				// labelInValue - Not directly supported, onChange provides value directly
				labels={planOptions} // Use planOptions directly as labels
				values={planOptions} // Use planOptions directly as values
				selected={currentPlan} // Use currentPlan directly for selected value
				style={{ width: 350 }} // Keep style for now
				onChange={(value) => setNewPlan(value)} // Pass value directly to setNewPlan
			/>
		</CBModal>
	)
}

export default EditPlanModal
